export default function PrincipleItem({ title, description, accent = false }) {
  return (
    <div
      className={`border-t-2 pt-6 ${accent ? "border-omnyx-teal" : "border-site-hairline"}`}
    >
      <h3 className="font-heading text-base font-bold text-site-ink">{title}</h3>
      <p className="mt-2 text-sm leading-relaxed text-site-muted">{description}</p>
    </div>
  );
}
